import { useApiQuery } from '../api';
import { useBuildVars } from '../config';

export type VendorLookUpResponse = {
  vendorCodes: null;
  vendorID: number;
  vendorName: string;
};

export function useGetVendorList() {
  const buildVars = useBuildVars();
  return useApiQuery<VendorLookUpResponse[]>(
    '/system.webapi.gds/api/v1/gdsCoreApiVendor/vendorlist',
    undefined,
    undefined,
    undefined,
    {
      host: buildVars.VP_API_BASE,
    }
  );
}

export type VendorLookUpRequest = {
  countryCode: string;
  vendorNameToSearch: string;
};

export function useVendorLookUp(params: VendorLookUpRequest) {
  const buildVars = useBuildVars();
  return useApiQuery<VendorLookUpResponse[]>(
    '/system.webapi.gds/api/v1/gdsCoreApiVendor/vendor',
    params,
    { enabled: params.vendorNameToSearch.length > 1 },
    undefined,
    {
      host: buildVars.VP_API_BASE,
    }
  );
}
